<script>
import { Bar } from "vue-chartjs";

export default {
  name: "BarLineChart",
  extends: Bar,
  props: {
    chartdata: {
      type: Object,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
  },
  watch: {
    chartdata: {
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.renderChart(newValue, this.options);
        }
      },
    },
  },
  mounted() {
    this.renderChart(this.chartdata, this.options);
  },
};
</script>
